import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate, Link } from 'react-router-dom';
import { updateMyProfile, changePassword, deleteSelf, resendVerification } from '../actions/authActions';

export default function Profile() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { user, capabilities } = useSelector(s => s.auth);
  if (!user) return null;

  const [profile, setProfile] = useState({ name: user.name || '', username: user.username || '' });
  const [pw, setPw] = useState({ current: '', next: '', confirm: '' });
  const [status, setStatus] = useState({ kind: '', text: '' });
  const [busy, setBusy] = useState(false);

  const saveProfile = async (e) => {
    e.preventDefault(); setBusy(true);
    const res = await dispatch(updateMyProfile(profile));
    setBusy(false);
    setStatus(res.ok ? { kind: 'success', text: 'Profile saved.' } : { kind: 'error', text: res.error });
  };
  const savePassword = async (e) => {
    e.preventDefault();
    if (pw.next !== pw.confirm) { setStatus({ kind: 'error', text: 'Passwords do not match.' }); return; }
    setBusy(true);
    const res = await dispatch(changePassword(pw.current, pw.next));
    setBusy(false);
    if (res.ok) { setPw({ current: '', next: '', confirm: '' }); setStatus({ kind: 'success', text: 'Password changed.' }); }
    else setStatus({ kind: 'error', text: res.error });
  };
  const removeMe = async () => {
    if (!confirm('Delete your account? This is irreversible.')) return;
    const res = await dispatch(deleteSelf());
    if (res.ok) navigate('/');
    else setStatus({ kind: 'error', text: res.error });
  };
  const resend = async () => {
    const res = await dispatch(resendVerification());
    setStatus(res.ok ? { kind: 'success', text: 'Verification email sent.' } : { kind: 'error', text: res.error });
  };

  return (
    <section className="section">
      <h1>Your profile</h1>

      {!user.emailVerified && (
        <div className="card" style={{borderColor:'#f0c4c4',background:'#fff7f7'}}>
          <strong>Your email is not verified.</strong>
          <p className="muted">Some features require a verified email.</p>
          <button className="btn-ghost" type="button" onClick={resend}>Resend verification email</button>
        </div>
      )}

      <div className="card">
        <h2>Basic info</h2>
        <form className="auth-form" onSubmit={saveProfile} style={{maxWidth:'520px'}}>
          <label>Email<input type="email" value={user.email} readOnly /></label>
          <label>Name<input value={profile.name} onChange={e => setProfile({...profile, name: e.target.value})} /></label>
          <label>Username<input value={profile.username} onChange={e => setProfile({...profile, username: e.target.value})} /></label>
          <button className="btn-primary" type="submit" disabled={busy}>Save</button>
        </form>
      </div>

      <div className="card">
        <h2>Change password</h2>
        <form className="auth-form" onSubmit={savePassword} style={{maxWidth:'520px'}}>
          <label>Current password<input required type="password" value={pw.current} onChange={e => setPw({...pw, current: e.target.value})} /></label>
          <label>New password<input required type="password" minLength={8} value={pw.next} onChange={e => setPw({...pw, next: e.target.value})} /></label>
          <label>Confirm new password<input required type="password" value={pw.confirm} onChange={e => setPw({...pw, confirm: e.target.value})} /></label>
          <button className="btn-primary" type="submit" disabled={busy}>Change password</button>
        </form>
      </div>

      <div className="card">
        <h2>Your role &amp; permissions</h2>
        <p>Role: <strong>{user.role}</strong></p>
        <p className="muted">Effective capabilities ({capabilities.length}):</p>
        <ul className="features" style={{columns:2}}>
          {capabilities.map(c => <li key={c}><code>{c}</code></li>)}
        </ul>
      </div>

      <div className="card">
        <h2>API keys</h2>
        <p className="muted">Personal access tokens for the JSON API.</p>
        <Link to="/account/api-keys" className="btn-ghost">Manage API keys →</Link>
      </div>

      <div className="card" style={{borderColor:'#f0c4c4'}}>
        <h2>Danger zone</h2>
        <p>Delete your account permanently. Your data is soft-deleted; we keep audit logs for fraud prevention but your name and email are anonymized.</p>
        <button type="button" onClick={removeMe} style={{background:'#b53b3b',color:'white',padding:'.7rem 1.2rem',border:0,borderRadius:'6px',fontWeight:700,cursor:'pointer'}}>Delete my account</button>
      </div>

      {status.text && <p className={`status ${status.kind}`}>{status.text}</p>}
    </section>
  );
}
